import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import HeadingM from "../../components/shared/HeadingM"
import Layout from "../../components/sutea/Layout"
import SEO from "../../components/Seo"
import About from "../../components/shared/usage/About"
import Fee from "../../components/shared/usage/Fee"
import Procedure from "../../components/shared/usage/Procedure"
import { PAGE } from "../../constants"

const usage = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.usage} siteTitle="すてあ" />
      <HeadingL title={PAGE.title.usage} target="sutea" />
      <HeadingM title="ご利用について" target="sutea" />
      <About />
      <HeadingM title="ご利用料金" target="sutea" />
      <Fee target="sutea" />
      <HeadingM title="ご利用手順" target="sutea" />
      <Procedure target="sutea" />
    </Layout>
  )
}

export default usage
